import { Components, Theme } from '@mui/material/styles';

export const flowInputBase: Components<Theme>['MuiInputBase'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: 'inherit',
      caretColor: theme.palette.brand.primary,
      [theme.breakpoints.up('xs')]: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
      },
      '&.Mui-focused': {
        color: theme.palette.text.primary,
      },
      '&&': {
        '&:before': {
          borderColor: 'currentColor',
        },
        '&:after': {
          borderColor: 'currentColor',
        },
      },
    }),
    input: ({ theme }) => ({
      height: 'auto',
      // change font for password field, SkodaNext font uses '>>>' instead '***' symbol for the password
      '&[type=password]': {
        fontFamily: 'Arial',
      },
      // placeholder
      '&::-webkit-input-placeholder': {
        opacity: '1',
        color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os200 : theme.palette.onSurface.os600,
      },
      '&.Mui-disabled': {
        // remove default @mui style and use currentColor instead
        WebkitTextFillColor: 'unset',
        // placeholder
        '&::-webkit-input-placeholder': {
          color: 'inherit',
        },
      },
    }),
    inputMultiline: {
      // increase size of thumb
      '&::-webkit-scrollbar-thumb': {
        height: '50%',
      },
    },
  },
};
